import React,{useEffect,useState} from 'react';
import {Sun,Moon} from 'lucide-react';
function applyTheme(mode){
 document.documentElement.dataset.theme=mode;
}
export default function ThemeToggle(){
 const [theme,setTheme]=useState('light');
 useEffect(()=>{let saved;try{saved=localStorage.getItem('bizaipro-theme');}catch{}const mode=saved==='dark'||saved==='light'?saved:matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light';applyTheme(mode);setTheme(mode);},[]);
 function toggle(){const next=theme==='dark'?'light':'dark';applyTheme(next);setTheme(next);try{localStorage.setItem('bizaipro-theme',next);}catch{}}
 return <button type="button" className="icon-button theme-toggle" onClick={toggle} aria-label={theme==='dark'?'Switch to light mode':'Switch to dark mode'} title={theme==='dark'?'Switch to light mode':'Switch to dark mode'} aria-pressed={theme==='dark'}>{theme==='dark'?<Sun size={19}/>:<Moon size={19}/>}</button>;
}
